document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('slideshow-slide');
  const thumbnails = gallery.querySelectorAll('.slideshow-controls__thumbnail');

  // 隐藏所有幻灯片，只显示第一张
  slides.forEach((slide, i) => {
    slide.style.display = i === 0 ? 'block' : 'none';
  });

  // 点击缩略图切换大图
  thumbnails.forEach((thumb, i) => {
    thumb.addEventListener('click', function() {
      slides.forEach(s => s.style.display = 'none');
      slides[i].style.display = 'block';
      thumbnails.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });
});
